import { ITeam } from "@gtmhub/teams";
import { stratify } from "d3";
import { IdMap } from "@gtmhub/util";
import { TreeDataNode } from "./tree-models";

/**
 * createTeamsTree
 * Converts GTMHUB teams data to a D3-compatible hierarchy structure. This function was originally part of the first Organization Tree.
 * The code was extracted without changes.
 *
 * Note: both TreeDataNode and HierarchyNode<ITeam> match the returned structure, so typecasting to either of them is safe.
 */
export function createTeamsTree(teams: ITeam[], teamsIdMap: IdMap<ITeam>): TreeDataNode {
  const fakeRoot: ITeam = { id: "root" };

  const buildTree = stratify<ITeam>()
    .id((d) => d.id)
    .parentId((d) => {
      if (d.id === fakeRoot.id) {
        return null;
      }

      return !d.parentId || !teamsIdMap[d.parentId] ? fakeRoot.id : d.parentId;
    });

  return buildTree([...teams, fakeRoot]) as TreeDataNode; // HierarchyNode is fully compatible with TreeDataNode
}
